<template lang="html">
    <section class="title-order-windows">
        <header>
            <h1>
                <span><i class="far fa-calendar-alt"></i></span> {{ orderTitle }}
            </h1>
        </header>
    </section>
</template>

<script lang="js">
  export default  {
    name: 'title-order-windows',
    props: ["orderTitle"]
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
.title-order-windows {
    h1 {
        font-family: "oswald-regular", sans-serif;
        font-size: 25px;
        text-transform: uppercase;
        span {
            background: $color4;
            border-radius: 50%;
            width: 30px;
            height: 30px;
            vertical-align: middle;
            display: inline-block;
            text-align: center;
            line-height: 28px;
            font-size: 17px;
            svg {
                color: white;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// titleOrderWindows.vue?d14f8dea